export const FLAG_KEYS = {
  DISABLE_UPSCALING: "DISABLE_UPSCALING",
  HIDE_BACKGROUND_GENERATION: "HIDE_BACKGROUND_GENERATION",
  HIDE_IMAGE_EDITING: "HIDE_IMAGE_EDITING",
  HIDE_STORY_BOARD: "HIDE_STORY_BOARD",
  HIDE_VIDEO_GENERATION: "HIDE_VIDEO_GENERATION",
  DISABLE_LIFESTYLE_ENTER_DESCRIPTION: "DISABLE_LIFESTYLE_ENTER_DESCRIPTION",
  USE_DS_CONCEPT: "USE_DS_CONCEPT",
  NOT_USE_MERGED_PP_FG_FLOW: "NOT_USE_MERGED_PP_FG_FLOW",
  ENABLE_NANO_BANANA_DS_API: "ENABLE_NANO_BANANA_DS_API",
  HIDE_REFERENCE_IMAGE_BACKGROUND: "HIDE_REFERENCE_IMAGE_BACKGROUND",
  CONTENT_GENERATION_FLOW_ENABLED: "CONTENT_GENERATION_FLOW_ENABLED",
  ENABLE_IMAGE_GALLERY: "ENABLE_IMAGE_GALLERY",
  ENABLE_GTIN_VALIDATION: "ENABLE_GTIN_VALIDATION",
  ENABLE_VIDEO_SCRIPT_TO_VIDEO: "ENABLE_VIDEO_SCRIPT_TO_VIDEO",
  ENABLE_VIDEO_PROMPT_ENHANCEMENT: "ENABLE_VIDEO_PROMPT_ENHANCEMENT",
  DISABLE_IMAGE_EDITING_FLOW: "DISABLE_IMAGE_EDITING_FLOW",
  ENABLE_LLM_TRANSLATION: "ENABLE_LLM_TRANSLATION",
  ENABLE_NEW_IMAGE_STREAM_API: "ENABLE_NEW_IMAGE_STREAM_API",
  ENABLE_UPLOAD_FILE_SCAN: "ENABLE_UPLOAD_FILE_SCAN",
};
